export default __webpack_public_path__ + "static/media/info_portal_n.ab50e7c5.svg";